const SituationEnum = Object.freeze({
    ATIVO: "ATIVO",
    INATIVO: "INATIVO",
    DEMITIDO: "DEMITIDO",
    AFASTADO: "AFASTADO",
    FERIAS: "FERIAS",
    PENDENTE: "PENDENTE"
});

export default SituationEnum;